import React from "react";

const sponsors = [
  {
    title: "BMS logo",
    description:
      "This platform is proudly supported with funding from BMS. BMS had no involvement in the content creation.",
    logo: "/melanoma/bms_logo.png",
    size: 200,
  },
  {
    title: "MSD logo",
    description:
      "Melanoma Ireland – a tailored patient information platform for Skin Oncology patients was partially funded by MSD.",
    logo: "/melanoma/MSD_Logo.png",
    size: 100,
  },
];

const Footer = () => {
  return (
    <footer style={{ padding: "3rem 0", backgroundColor: "#f9fafb" }}>
      <div className="container" style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1.5rem" }}>
        <div>
          <h3 
            style={{ 
              fontWeight: "600", 
              fontSize: "0.85rem", 
              textTransform: "uppercase", 
              letterSpacing: "1px", 
              color: "#6B7280", 
              marginBottom: "1rem" 
            }}
          >
            Sponsors
          </h3>
          <div className="d-flex flex-column flex-md-row align-items-start">
            {sponsors.map((sponsor, index) => (
              <div 
                className={`d-flex flex-column ${index > 0 ? 'sponsor-divider' : 'mb-0'} pr-md-4`} 
                style={{ flex: 1 }}
                key={index}
              >
                <img
                  src={sponsor.logo}
                  alt={sponsor.title}
                  width={sponsor.size}
                  className="mb-2"
                  style={{ objectFit: "contain", height: "auto" }}
                />
                <small style={{ color: "#6B7280", lineHeight: "1.5" }}>
                  {sponsor.description}
                </small>
              </div>
            ))}
          </div>

          <div className="mt-5">
            <h3 style={{ fontWeight: "600", fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "1px", color: "#6B7280", marginBottom: "1rem" }}>Platform & Digital Health Partner</h3>
            <img src="/img/mps-logo.png" alt="myPatientSpace" height="35" style={{ opacity: 0.9 }} className="mb-2" />
            <small style={{ color: "#6B7280", lineHeight: "1.5", display: "block" }}>
              Proudly supporting Melanoma Ireland through digital innovation and patient engagement technology.
            </small>
          </div>
        </div>
        <div
          style={{
            marginTop: "3rem",
            paddingTop: "1.5rem",
            borderTop: "1px solid #E5E7EB",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <div className="d-flex">
            <img
              src={"/melanoma/logo.png"}
              alt="melanoma"
              width={30}
              height={40}
              className="mr-2"
            />
            <p
              style={{ color: "#6B7280", fontSize: "0.875rem" }}
              className="my-auto"
            >
              © 2025 Melanoma Ireland. All rights reserved.
            </p>
          </div>
          <div style={{ display: "flex", gap: "1.5rem", marginTop: "1rem", flexWrap: "wrap", justifyContent: "center" }}>
            {[
              { label: "Privacy Policy", url: "https://mypatientspace.com/privacy-html/" },
              { label: "Terms & Conditions", url: "https://mypatientspace.com/terms-and-conditions-html/" },
              { label: "Information Security", url: "https://mypatientspace.com/information-security/" },
            ].map(
              (policy) => (
                <a
                  key={policy.label}
                  href={policy.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: "0.875rem",
                    color: "#6B7280",
                    textDecoration: "none",
                    transition: "color 0.3s",
                  }}
                >
                  {policy.label}
                </a>
              )
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
